export var createMuiListSubheaderOverrides = function (_a) {
    var tokens = _a.tokens;
    return {
        styleOverrides: {
            sticky: {
                backgroundColor: tokens.color_bg_layer,
            },
        },
    };
};
